export default __webpack_public_path__ + "static/media/Next.6dde87ad.webp";